<template>
  <div class="checkout-delivery">
    <div class="headline-sm">תנאי אספקה</div>
    <checkout-deliveries v-model="checkout.shipping_method_code" @update:modelValue="(e) => $emit('change', e)"/>
    <checkout-address v-model:address="checkout.address" v-if="showAddress"/>
    <Pickup v-if="checkout.shipping_method_code === 'pickup'" v-model="checkout.pickup_point_id" @update:modelValue="(e) => $emit('pickup', e)"></Pickup>
  </div>
</template>

<script>
import CheckoutDeliveries from "./deliveries/deliveries";
import CheckoutAddress from "./address/address";
import Pickup from "./deliveries/pickup.vue";

export default {
  name: "CheckoutDelivery",
  props: ['checkout', 'data'],
  components: {
    CheckoutDeliveries,
    CheckoutAddress,
    Pickup
  },
  computed: {
      showAddress() {
      return this.checkout.shipping_method_code === 'ups'
    },
  }
}
</script>

<style scoped>

</style>
